import { Prisma } from '@repo/database/src/types';
import type { AgentDealUpdateRequest, User } from '@repo/database/src/types';
import { Transform, Type } from 'class-transformer';
import { IsBoolean, IsObject, IsOptional, IsString, IsUUID, ValidateNested } from 'class-validator';

import { PaginationOptionsDto } from '../../pagination-options-types';
import { AdminAgentDealDto } from './admin-agent-deals-query.dto';

export class AdminAgentDealUpdateRequestsFilterDto {
  @IsOptional()
  @IsBoolean()
  @Transform(({ value }) => value === true || value === 'true')
  applied?: boolean;

  @IsOptional()
  @IsString()
  search?: string;

  @IsOptional()
  @IsUUID('4')
  userId?: string;

  @IsOptional()
  @IsUUID('4')
  agentDealId?: string;
}

export class GetAdminAgentDealUpdateRequestsDto extends PaginationOptionsDto {
  @IsObject()
  @ValidateNested()
  @IsOptional()
  @Type(() => AdminAgentDealUpdateRequestsFilterDto)
  filter?: AdminAgentDealUpdateRequestsFilterDto;

  @IsOptional()
  sorts?: Array<{ field: keyof AgentDealUpdateRequest | string; order: Prisma.SortOrder }>;
}

export interface AdminAgentDealUpdateRequestDto
  extends Omit<AgentDealUpdateRequest, 'createdAt' | 'updatedAt' | 'validFrom' | 'currentCycle'> {
  createdAt: string;
  updatedAt: string;
  validFrom: string;
  currentCycle: string;
  user?: User;
  createdByUser?: User;
  agentDeal?: AdminAgentDealDto;
}

export interface AdminAgentDealUpdateRequestsResponseDto {
  items: AdminAgentDealUpdateRequestDto[];
  totalCount: number;
  skip: number;
  take: number;
}
